import { isInstanceOf, } from "./aux";
import { isPart, } from "./documentdialog";
import { isArray, } from "./wsi4_typeguards";
export function isDialogData(t) {
    const typeGuardMap = {
        selection: (arg) => isArray(arg, isPart),
    };
    return isInstanceOf(t, typeGuardMap);
}
